import { useSelector } from 'hooks/utils';
import { UserDetails } from 'api/data/accounts';
import { GenericMap } from 'types/index';

export function useUsers(): GenericMap<UserDetails> {
	return useSelector(state => state.data.accounts.users.byEmail);
}
